import { Observable, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { NotificationService } from '../../services/notification.service';
import { hideLoading } from '../../state/app/app.actions';

export function handleError<T>(
  operation = 'operation',
  notificationService: NotificationService,
  store: Store
) {
  return (error: any): Observable<T> => {
    console.error(error);
    console.log(`${operation} failed: ${error.message}`);
    
    notificationService.showNotification(
      'Error fetching data',
      'Close',
      'error',
      Infinity
    );
    
    store.dispatch(hideLoading());
    
    return throwError(
      () => new Error(`Operation ${operation} failed: ${error.message}`)
    );
  };
}

export function cleanSearchParams<T>(params: T): T {
  const cleanParams = { ...params };
  Object.keys(cleanParams).forEach((key) => {
    if (cleanParams[key]?.length === 0) {
      cleanParams[key] = null;
    }
    if (cleanParams[key]?.length === 1 && cleanParams[key][0] == null) {
      cleanParams[key] = null;
    }
  });
  return cleanParams;
} 

